<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body"  style="overflow-y: scroll;" >
				
			<el-form class="dataForm" ref="form" :model="parameter" :inline="true" label-width="120px">
				<el-row>
					<el-col :span="8">
						<el-form-item label="Sprint名称:">{{ parameter.sprName }} </el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="累积进度:"> {{ parameter.kfAdvance?(parameter.kfAdvance*100).toFixed(1):0 }}% </el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="累积完成工时:">{{ parameter.wchours }} / {{ parameter.hopegs }}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="sprint代办:">{{ sbl.name }} </el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="计划工时:"> {{ sbl.hopegs }}</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="计划周期:">{{ sbl.pbgntm }} / {{ sbl.pendtm }}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="目   标:"  > <span v-html="sbl.pgoal"></span></el-form-item>
					</el-col>
					<el-col :span="24" v-if="sbl.remark">
						<el-form-item label="备   注:"  > <span v-html="sbl.remark"></span></el-form-item>
					</el-col> 
				</el-row>
			</el-form>
		 
			<el-table class="table" style="overflow: overflow;" :data="listDatas" stripe border   v-loading="popupLoading">
				<el-table-column prop="wkdate" width="170" label="完成时间"></el-table-column>
				<el-table-column prop="dbColumn_pmid" width="90" label="成员"></el-table-column>
				<el-table-column prop="wchours" width="80" label="完成">
					<template slot-scope="props">
						{{ props.row.wchours }}
					</template>
				</el-table-column>
				<el-table-column prop="realgs" width="80" label="消耗">
					<template slot-scope="props">
						{{ props.row.realgs }}
					</template>
				</el-table-column>
				
				<el-table-column prop="kfAdvance" width="90" label="进度">
					<template slot-scope="props">
						{{ props.row.kfAdvance?(props.row.kfAdvance*100).toFixed(1):0 }}%
					</template>
				</el-table-column>

				<el-table-column prop="remark"   label="日志记录">
					<template slot-scope="props">
						<span v-if="props.row.remark" v-html="props.row.remark"></span>
						<span v-else v-html="props.row.plan"></span>
					</template>
				</el-table-column>

				<el-table-column label="操作" fixed="right" width="75px">
					<template slot-scope="scope">
						<div class="dataTable-operator">
							<el-button size="mini" v-if="isShow(scope.$index, scope.row)" type="danger"
								@click="remove(scope.$index, scope.row)">删除</el-button>
						</div>
					</template>
				</el-table-column>

			</el-table>

		
		
		</div>
		<div slot="footer">

			<el-button @click="close">关 闭</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/sprint/devRecord/devRecord.js';
import apiSBL from '@/api/sprint/sprintBacklog/sprintBacklog.js';
export default {
	name: 'edit',
	components: {
		popup
	},
	data() {
		return {
			popupLoading: false,

			parameter: {},
			listDatas: [],
			needReflushParent: false,
			me: {},
			sbl:{}
		};
	},
	methods: {
		isShow(idx, row) {

			if (idx == 0) {
				if ('ad' == this.me.role) {
					return true
				} else if (this.me.id == row.pmid && row.kfAdvance < 100) {
					return true
				}
			}



			return false
		},
		//打开弹框
		open(parameter, title, me, size) {

			this.parameter = parameter;

			this.me = me

			this.needReflushParent = false

			this.$refs.popup.open(title, "1200px");

			if (this.parameter.id) {    		       //3.修改
				this.$nextTick(() => {
					this.popupLoading = true;
					//清空内容
					this.listDatas = [];
					//查询一个待办下的全部开发记录
					apiSBL.toUpdate({ id: this.parameter.sbiId }, res => {

						this.sbl = res.data

						api.listBySBLId({ sblid: this.parameter.sbiId }, response => {
							this.listDatas = response.data;
							this.popupLoading = false;
						});
					})
				});
			}
		},//删除
		remove(idx, row) {
			this.$utils.confirm.warning('提示', '确定删除该条开发日志吗？', () => {
				api.remove(
					{ id: row.id },
					response => {
						this.$utils.msg.success(response.msg);

						if (this.listDatas.length == 1) {
							this.close();
							this.$parent.list();
						} else {
							this.listDatas.splice(idx, 1)
							this.needReflushParent = true
						}
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//关闭弹框
		close() {

			this.$refs.popup.close();
			if (this.needReflushParent) {
				this.$parent.list();
			}
		}
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
.el-table--border{
	overflow: visible;
	 
}
</style>
